module.exports = __webpack_public_path__ + "static/media/pltw_mass_logo_20190924a.6cb7bc44.png";